/**
 * V9.11 — Rendu d'un article en Markdown léger (GFM).
 *
 * Sécurisé par défaut : react-markdown rend uniquement du Markdown (pas de HTML brut),
 * les liens externes s'ouvrent dans un nouvel onglet avec rel="noreferrer".
 * Les images sont rendues avec lazy-loading.
 */
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export function MarkdownRenderer({ children, className = "" }) {
  return (
    <div
      className={
        "prose prose-sm sm:prose-base max-w-none break-words " +
        "prose-headings:font-display prose-headings:font-bold " +
        "prose-h1:text-2xl sm:prose-h1:text-3xl prose-h2:text-xl sm:prose-h2:text-2xl prose-h3:text-lg " +
        "prose-p:leading-relaxed prose-img:rounded-lg prose-img:max-h-[480px] prose-img:object-cover " +
        "prose-a:text-[hsl(var(--aito-lagoon))] prose-a:no-underline hover:prose-a:underline " +
        "prose-blockquote:border-l-[hsl(var(--aito-gold))] prose-blockquote:text-muted-foreground " +
        "prose-code:bg-muted prose-code:px-1.5 prose-code:py-0.5 prose-code:rounded prose-code:text-xs " +
        className
      }
    >
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: ({ node, ...props }) => (
            <a {...props} target="_blank" rel="noreferrer noopener" />
          ),
          img: ({ node, ...props }) => (
            
            <img loading="lazy" {...props} />
          ),
        }}
      >
        {children || ""}
      </ReactMarkdown>
    </div>
  );
}
